/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Description_Length_LabelInputs */



/**
* | output |
* | --- |
* | "Shot Description Length" |
*
* @param {Sd_Description_Length_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_description_length_label = /** @type {((inputs?: Sd_Description_Length_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Description_Length_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Longueur de la description des plans")
	if (locale === "de") return /** @type {LocalizedString} */ ("Länge der Einstellungsbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lunghezza descrizione inquadratura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Длина описания плана")
	if (locale === "es") return /** @type {LocalizedString} */ ("Longitud de la descripción del plano")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述长度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット説明の長さ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण की लंबाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comprimento da descrição do plano")
	return /** @type {LocalizedString} */ ("Shot Description Length")
});